<form [formGroup]="form">
	<div  style="text-align: center;">
        <p>Aprobación del reintegro</p>
          <mat-radio-group class="formRadio" formControlName="aprobado" aria-label="Select an option">
            <mat-radio-button value="aprobado">Aprobado</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="rechazado">Rechazado</mat-radio-button>
          </mat-radio-group>
    </div>
</form>
